// ./client/src/context/announcement/announcementInitialState.js

export default {
    // Announcements
    announcements: [],
    studentAnnouncements: [],
    adminAnnouncements: [],
    currentAnnouncement: null,
    announcementHistory: [],
    
    // Pagination
    currentPage: 1,
    totalPages: 1,
    totalAnnouncements: 0,
    
    // Statistics
    totalRecipients: 0,
    sentCount: 0,
    readCount: 0,
    unreadCount: 0,
    lastSentAnnouncement: null,
    // UI State
    isLoading: false,
    error: null,
    success: null
};